import { hashHistory, useRouterHistory } from 'react-router';
import { createHistory } from 'history';
import * as featureFlags from 'login-utils/featureFlags';

const browserHistory = useRouterHistory(createHistory)({
  basename: '/entry',
});

function getHistory() {
  return featureFlags.isEnabled('removeHashFromLoginRoutes_20191014') ? browserHistory : hashHistory;
}

export function getBasePath() {
  return featureFlags.isEnabled('removeHashFromLoginRoutes_20191014') ? '/entry' : '#/';
}

export default getHistory();
